import * as React from 'react';
import { splitNumber } from '@/utils/common';

export interface Props {
  meetingId: string | number;
}

const MeetingId: React.FC<Props> = props => {
  const { meetingId } = props;
  return (
    <>
      {splitNumber(Number(meetingId))
        .split(' ')
        .map((n, index) => {
          return (
            n && (
              <span key={index} style={{ display: 'inline-block', paddingRight: '4px' }}>
                {n}
              </span>
            )
          );
        })}
    </>
  );
};

export default MeetingId;
